import * as React from 'react';

import GuardVisionStatsTable from './guardVisionStatsTable';
import { CanEditTeamsBanner } from '../../../components/teamBanner';

const GuardVisionStats: React.FC = () => {
	return (
		<>
			<CanEditTeamsBanner />
			<GuardVisionStatsTable />
		</>
	);
};

export default GuardVisionStats;
